<template>
<div>
  <section class="flex block__slideout">
    <b-row class="block__profile">
      <div class="mobile">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
              <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h3>{{general.profileTitle}}</h3>
        </div>
        <div class="sep"></div>
      </div>

      <div class="scrollable col">

        <b-list-group>
          <b-list-group-item>

            <router-link class="btn btn-profiler" :to="{ name: 'profileInfo'}" v-if="isMobile">
              <div class="left">
                <div class="btn-profile wrapper-icon">
                  <div class="back"></div>
                  <div class="initial">{{initial}}</div>
                </div>
                <div class="fullname">
                  {{fullName}}
                </div>
              </div>

              <div class="arrow">
                  <font-awesome-icon :icon="['far', 'angle-right']"/>
              </div>
          </router-link> 

            <a class="btn btn-profiler" v-b-toggle.sidebar-2 v-else>
              <div class="left">
                <div class="btn-profile wrapper-icon">
                  <div class="back"></div>
                  <div class="initial">{{initial}}</div>
                </div>
                <div class="fullname">
                  {{fullName}}
                </div>
              </div>

              <div class="arrow">
                  <font-awesome-icon :icon="['far', 'angle-right']"/>
              </div>
          </a> 

          </b-list-group-item>





          <b-list-group-item>
            <router-link class="btn btn-collab" :to="{ name: 'profileCollab'}" v-if="isMobile">
              <div class="left">
                <div class="wrapper-icon">
                  <font-awesome-icon :icon="['far', 'users-medical']" />
                </div>
                {{general.profileTitleCollaborators}}
              </div>
              <div class="arrow">
                  <font-awesome-icon :icon="['far', 'angle-right']"/>
              </div>            
            </router-link> 

            <a class="btn btn-collab" v-b-toggle.sidebar-3 v-else>
              <div class="left">
                <div class="wrapper-icon">
                  <font-awesome-icon :icon="['far', 'users-medical']" />
                </div>
                {{general.profileTitleCollaborators}}
              </div>
              <div class="arrow">
                  <font-awesome-icon :icon="['far', 'angle-right']"/>
              </div>            
            </a> 
          </b-list-group-item>



          <b-list-group-item>
            <router-link class="btn btn-notification" :to="{ name: 'profileNotification'}" v-if="isMobile">
              <div class="left">
                <div class="wrapper-icon">
                  <font-awesome-icon :icon="['far', 'bell']" />            
                </div>
                {{general.profileTitleNotifications}}
              </div>
              <div class="arrow">
                  <font-awesome-icon :icon="['far', 'angle-right']"/>
              </div>            
            </router-link> 


            <a class="btn btn-notification"  v-b-toggle.sidebar-4 v-else>
              <div class="left">
                <div class="wrapper-icon">
                  <font-awesome-icon :icon="['far', 'bell']" />            
                </div>
                {{general.profileTitleNotifications}}
              </div>
              <div class="arrow">
                  <font-awesome-icon :icon="['far', 'angle-right']"/>
              </div>            
            </a> 
          </b-list-group-item>













          <b-list-group-item>
            <button class="btn btn-disconnect" v-on:click="disconnect()">
              <div class="wrapper-icon">
                <font-awesome-icon :icon="['fas', 'sign-in']" />            
              </div>
                {{general.profileTitleDisconnect}}
            </button>
          </b-list-group-item>
        </b-list-group>

      </div>

    </b-row>


    <!-- SIDEBAR -->
    <b-sidebar id="sidebar-2" right shadow width="360px" v-if="!isMobile">
      <ProfileInfo  v-if="!isMobile" ></ProfileInfo>
    </b-sidebar>
    <!-- SIDEBAR -->

    <!-- SIDEBAR -->
    <b-sidebar id="sidebar-3" right shadow width="360px" v-if="!isMobile">
      <ProfileCollab  v-if="!isMobile"></ProfileCollab>
    </b-sidebar>
    <!-- SIDEBAR -->

    <!-- SIDEBAR -->
    <b-sidebar id="sidebar-4" right shadow width="360px" v-if="!isMobile">
      <ProfileNotifications  v-if="!isMobile"></ProfileNotifications>
    </b-sidebar>
    <!-- SIDEBAR -->
  </section>

      <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
    <transition name="slide" v-if="isMobile">      
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition> 
  <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
  </div>
</template>




<script>
import { mapGetters } from 'vuex'
import ProfileInfo from '../profile/ProfileInfo'
import ProfileCollab from '../profile/ProfileCollab'
import ProfileNotifications from '../profile/ProfileNotifications'
import ParentMixin from '../../ParentMixin'

export default {
    name:"profileHome",
    components:{
      ProfileInfo,
      ProfileCollab,
      ProfileNotifications           
    }, 
    mixins:[
      ParentMixin
    ],
    computed: {
      ...mapGetters([
        'getGeneral',
        'getInitial',
        'getFullName'
      ])
    },
    data () {
      return {
        general:"",
        isLoading:true,
        initial:'',
        fullName:'',
      }
    },
    created (){
      this.general = this.getGeneral;
      this.initial = this.getInitial;
      this.fullName = this.getFullName;

    // setTimeout(() => {
    //     this.isLoading = false;
    //   },2000)         
    },    
    methods : {
      goBack() {
        this.$router.push({name: "home"});  
      },   
      disconnect: function (){
        this.$store.dispatch('disconnect');
      },
    }
};
</script>
